/* Rawtorque account motion.

   Scroll reveal for the account pages. Elements carrying data-rt-reveal fade
   and rise as they enter the viewport, staggered by the attribute's value in
   milliseconds.

   Two safety properties matter more than the effect:

   1. Nothing is ever hidden unless this script is running. The hiding rule is
      scoped to .rt-motion on <html>, which only this file adds. If the script
      fails to load, fails to parse, or is blocked, the page renders normally
      with no animation and no invisible content.

   2. A failsafe reveals everything after 2.5 seconds regardless of the
      observer. A customer must never lose their order history to a
      misbehaving IntersectionObserver.

   Only opacity and transform are animated, both of which the compositor
   handles without layout or paint work. This store's INP is dominated by input
   delay, so main-thread work during scroll is the thing to avoid. */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) { return; }

  var root = document.documentElement;
  var revealed = false;

  function revealAll() {
    if (revealed) { return; }
    revealed = true;
    var all = document.querySelectorAll('[data-rt-reveal]');
    for (var i = 0; i < all.length; i++) { all[i].classList.add('is-in'); }
  }

  function init() {
    var els = document.querySelectorAll('.rt-a [data-rt-reveal]');
    if (!els.length) { return; }

    root.classList.add('rt-motion');

    if (!window.IntersectionObserver) { revealAll(); return; }

    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var e = entries[i];
        if (!e.isIntersecting) { continue; }
        (function (el) {
          var delay = parseInt(el.getAttribute('data-rt-reveal') || '0', 10) || 0;
          if (delay) {
            setTimeout(function () { el.classList.add('is-in'); }, delay);
          } else {
            el.classList.add('is-in');
          }
        }(e.target));
        io.unobserve(e.target);
      }
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.04 });

    for (var i = 0; i < els.length; i++) { io.observe(els[i]); }

    // Failsafe. Content is never worth losing to an effect.
    setTimeout(revealAll, 2500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
